import {NgModule} from "@angular/core";
import {CalendarComponent} from "angular2-fullcalendar/src/calendar/calendar";
import {BusinessInformationComponent} from "./business-information/business-information.component";
import {TimepickerModule, ModalModule, TabsModule, AccordionModule} from "ng2-bootstrap";
import {RouterModule} from "@angular/router";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DataTableModule} from "../../components/common/datatables/datatable.module";
import {Ng2GoogleChartsModule} from "ng2-google-charts";
import {CommonModule} from "@angular/common";
import {BusinessLocationComponent} from "./business-location/business-location.component";
import {MailingAddressComponent} from "./mailing-address/mailing-address.component";
import {OwnerInformationComponent} from "./owner-information/owner-information.component";
import {ContactsComponent} from "./contacts/contacts.component";
import {ClientsService} from "../../models/clients/clients.service";
import {ClientVolumesService} from "../../models/client-volumes/client-volumes.service";
import {ClientContactsService} from "../../models/client-contacts/client-contacts.service";
import {ClientBanksService} from "../../models/client-banks/client-banks.service";
import {ClientOwnersService} from "../../models/client-owners/client-owners.service";
import {ClientProcessorsService} from "../../models/client-processors/client-processors.service";
import {PricingsService} from "../../models/pricings/pricings.service";
import {ProvincesService} from "../../models/provinces/provinces.service";
import {AreaCodesService} from "../../models/area-codes/area-codes.service";
import {FundingInformationComponent} from './funding-information/funding-information.component';
import {DebtsService} from '../../models/debts/debts.service';
import {ClientInfoComponent} from './client-info/client-info.component';
import {SliderModule} from 'primeng/primeng';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmModule} from '../confirm/confirm.module';
import {NotesModule} from '../notes/notes.module';
import {ProcessorsService} from '../../models/processors/processors.service';
import { AgmCoreModule, MapsAPILoader, GoogleMapsAPIWrapper } from '@agm/core';
import {SpeedCalculatorComponent} from "./funding-information/speed-calculator/speed-calculator.component";
import {DatepickerModule} from '../../directives/datepicker/datepicker.module';
import {ScheduledCallbacksModule} from "../../modules/scheduled-callbacks/scheduled-callbacks.module";
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
    declarations: [
        BusinessInformationComponent,
        BusinessLocationComponent,
        MailingAddressComponent,
        OwnerInformationComponent,
        ContactsComponent,
        FundingInformationComponent,
        ClientInfoComponent,
        SpeedCalculatorComponent
    ],
    imports: [
        TimepickerModule.forRoot(),
        DatepickerModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DataTableModule,
        ModalModule,
        TabsModule,
        Ng2GoogleChartsModule,
        AccordionModule.forRoot(),
        CommonModule,
        SliderModule,
        NgbModule.forRoot(),
        ConfirmModule,
        NotesModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyC15buHUYqrTnW7PFEDuEO2gP3fPtTzyOQ'
        }),
        ScheduledCallbacksModule,
        PipesModule
    ],
    exports: [
        BusinessInformationComponent,
        BusinessLocationComponent,
        MailingAddressComponent,
        OwnerInformationComponent,
        ContactsComponent,
        FundingInformationComponent,
        ClientInfoComponent,
        SpeedCalculatorComponent
    ],
    providers: [
        ClientsService,
        ClientVolumesService,
        ClientContactsService,
        ClientBanksService,
        ClientOwnersService,
        ClientProcessorsService,
        PricingsService,
        ProvincesService,
        AreaCodesService,
        DebtsService,
        ProcessorsService,
        GoogleMapsAPIWrapper
    ],
    entryComponents: [
        SpeedCalculatorComponent
    ]
})

export class ClientFormsModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/client-forms.module.ts